import React from 'react';
import Router from 'next/router';
import PropTypes from 'prop-types';
import Head from 'next/head';

import Navbar from './Navbar';
import s from './styles.scss';

if (process.env.NODE_ENV !== 'production') {
  Router.events.on('routeChangeComplete', () => {
    const path = '/_next/static/css/styles.chunk.css';
    const chunksNodes = document.querySelectorAll(
      `link[href*="${path}"]:not([rel=preload])`
    );
    if (chunksNodes.length) {
      const timestamp = new Date().valueOf();
      chunksNodes[0].href = `${path}?ts=${timestamp}`;
    }
  });
}

const Layout = ({ children }) => (
  <div className={s.main}>
    {process.env.NODE_ENV !== 'production' && (
      <Head>
        <meta name="robots" content="noindex" />
      </Head>
    )}
    <Navbar />
    {children}
  </div>
);

Layout.propTypes = {
  children: PropTypes.element,
};

export default Layout;
